define('ROOM4.CCAGalleryShowcase.ShowcaseItem.View', [
    'Backbone',
    'room4_ccagalleryshowcase_item.tpl'
], function(
    Backbone,
    room4_ccagalleryshowcase_item_tpl
) {
    'use strict';

    // resolves a site path against the current origin; works in browsers and
    // in the SEO page generator (window.location exists in both)
    function toAbsoluteUrl(path) {
        if (!path || path === '#') {
            return '';
        }
        if (/^https?:\/\//i.test(path)) {
            return path;
        }
        return (
            window.location.protocol +
            '//' +
            window.location.host +
            (path.charAt(0) === '/' ? path : '/' + path)
        );
    }

    return Backbone.View.extend({
        template: room4_ccagalleryshowcase_item_tpl,

        getContext: function getContext() {
            var title = this.model.get('title') || '';
            var heroAlt = this.model.get('heroAlt') || title;
            var detailPath = this.model.get('detailPath') || '#';
            var absoluteDetailUrl = toAbsoluteUrl(detailPath);
            // the gallery detail page publishes its H1 as the entity name and
            // its meta description as the description; reusing them keeps the
            // itemid-merged entity consistent across both pages
            var galleryName = this.model.get('galleryName') || title;
            var galleryDescription = this.model.get('galleryDescription') || '';
            var position = this.model.collection
                ? this.model.collection.indexOf(this.model) + 1
                : 1;

            return {
                detailPath: detailPath,
                absoluteDetailUrl: absoluteDetailUrl,
                hasSchemaItem: !!absoluteDetailUrl,
                position: position,
                galleryName: galleryName,
                galleryDescription: galleryDescription,
                hasGalleryDescription: !!galleryDescription,
                heroUrl: this.model.get('heroUrl') || '',
                heroAlt: heroAlt,
                hasHeroUrl: !!this.model.get('heroUrl'),
                title: title
            };
        }
    });
});
